/* eslint-disable camelcase */

import refreshProbPerc_3 from './refresh_prob_perc_3.json';
import distances1_3 from './distances_1_3.json';
import similarities1_3 from './similarities_1_3.json';
import distances2_3 from './distances_2_3.json';
import similarities2_3 from './similarities_2_3.json';

export const refreshProbPercMap = {
  3: refreshProbPerc_3,
};

export const distancesMap = {
  '1-3': distances1_3,
  '2-3': distances2_3,
};

export const similaritiesMap = {
  '1-3': similarities1_3,
  '2-3': similarities2_3,
};
